<template>
  <!-- Rewards history Modal -->
  <transition name="fade">
    <div class="pay-overlay">
      <div class="modal-widget">
        <div class="modal-header">
          <h2 v-html="title + ' (' + participant.name + ')'"></h2>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <b-field label="Reward Amount">
              <b-numberinput v-model="form.amount" min="0"></b-numberinput>
            </b-field>
          </div>
          <div class="form-group" v-if="totalRewards > 0">
            <div class="balance-info">
              <div class="balance-item">
                <span class="label">Total Rewards Given:</span>
                <span class="amount">{{ totalRewards.toLocaleString() }} RWF</span>
              </div>
              <div class="balance-item remaining" v-if="remainingRewards !== null">
                <span class="label">Remaining Rewards:</span>
                <span class="amount">{{ remainingRewards.toLocaleString() }} RWF</span>
              </div>
            </div>
          </div>
          <div class="rewards-history-items">
            <div class="rewards-history-item" v-for="(item, index) in rewards_history" :key="index">
              <!-- Display mode -->
              <div v-if="!item.isEditing" class="reward-display">
                <div class="reward-info">
                  <h2>{{ item.amount.toLocaleString() }}</h2>
                  <p>{{ item.currency }}</p>
                </div>
                <div class="reward-actions">
                  <button class="btn-edit" @click="startEdit(index)" :disabled="isUpdating">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn-delete" @click="confirmDelete(index)" :disabled="isUpdating">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>

              <!-- Edit mode -->
              <div v-else class="reward-edit">
                <div class="edit-form">
                  <b-field label="Amount">
                    <b-numberinput v-model="item.editAmount" min="0" :disabled="isUpdating"></b-numberinput>
                  </b-field>
                  <b-field label="Currency">
                    <b-input v-model="item.editCurrency" :disabled="true"></b-input>
                  </b-field>
                </div>
                <div class="edit-actions">
                  <button class="btn-save" @click="saveEdit(index)" :disabled="isUpdating">
                    <i class="fas fa-check"></i>
                  </button>
                  <button class="btn-cancel" @click="cancelEdit(index)" :disabled="isUpdating">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="loading-widget" v-if="isLoadingRewardsHistory">
            <loading :height="50" color="var(--wecodefy-secondary-color,#9fc953)" :opacity="1" :width="50"
              :active.sync="isLoadingRewardsHistory" :is-full-page="false" :can-cancel="false" background-color="#fff"
              class="loader"></loading>
          </div>
        </div>
        <div class="modal-Footer">
          <button class="btn-success" @click="save()" :disabled="isSaving">
            <span v-if="isSaving">Adding Reward...</span>
            <span v-else>Save Reward</span>
          </button>
          <button class="btn-default" @click="close()">Close</button>
        </div>
      </div>
    </div>
  </transition>

</template>
<script>
export default {
  name: "movie-rewards-history",
  components: {},
  props: {
    title: {
      type: String,
      default: "Rewards History",
    },
    participant: {
      type: Object,
      default: () => { },
    },
    session: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      form: {
        participant_id: null,
        session_id: null,
        amount: 0,
        currency: "RWF",
      },
      isLoadingRewardsHistory: false,
      isSaving: false,
      isUpdating: false,
      rewards_history: [],
      remainingRewards: null,
    };
  },
  computed: {
    totalRewards() {
      return this.rewards_history.reduce((total, reward) => {
        return total + parseFloat(reward.amount || 0);
      }, 0);
    },
  },

  mounted() {
    let vm = this;
    vm.getParticipantRewardsHistory();
  },
  methods: {
    save() {
      let vm = this;

      // Validate amount
      if (!vm.form.amount || vm.form.amount <= 0) {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Invalid Amount",
          text: "Please enter a valid reward amount",
        });
        return;
      }

      // Check if amount exceeds remaining rewards
      if (vm.remainingRewards !== null && vm.form.amount > vm.remainingRewards) {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Amount Exceeds Limit",
          text: `Requested amount (${vm.form.amount}) exceeds remaining rewards (${vm.remainingRewards})`,
        });
        return;
      }


      vm.isSaving = true;
      vm.$store
        .dispatch("VOTING_ADD_PARTICIPANT_REWARD", vm.form)
        .then((response) => {
          vm.isSaving = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Success!",
            text: "Reward added successfully",
          });

          // Update remaining rewards if provided
          if (response.data && response.data.remaining_rewards !== undefined) {
            vm.remainingRewards = response.data.remaining_rewards;
          }

          // Reset form amount
          vm.form.amount = 0;

          // Refresh the rewards history
          vm.getParticipantRewardsHistory();
        })
        .catch((error) => {
          vm.isSaving = false;
          vm.$notify({
            group: "status",
            type: "error",
            title: "Error!",
            text: (error.response && error.response.data && error.response.data.message) || "Failed to add reward",
          });
        });
    },
    formatAmount() {
      // Optional: Format the amount as user types
      let vm = this;
      if (vm.form.amount) {
        vm.form.amount = parseFloat(vm.form.amount).toFixed(2);
      }
    },
    close() {
      let vm = this;
      vm.$emit("onClose");
    },
    getParticipantRewardsHistory() {
      let vm = this;
      vm.isLoadingRewardsHistory = true;
      vm.$store
        .dispatch("VOTING_GET_PARTICIPANT_REWARDS_HISTORY", {
          session_id: vm.participant.session_id,
          participant_id: vm.participant.id,
        })
        .then((response) => {
          vm.isLoadingRewardsHistory = false;
          vm.form.participant_id = vm.participant.id;
          vm.form.session_id = vm.session.id;
          vm.form.currency = vm.session.currency;
          vm.rewards_history = response.data.return;

          // Set remaining rewards if provided
          if (response.data && response.data.remaining_rewards !== undefined) {
            vm.remainingRewards = response.data.remaining_rewards;
          }

          console.log(vm.rewards_history);
        })
        .catch((error) => {
          vm.isLoadingRewardsHistory = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OPPS!!",
            text: "Failed to load participant rewards history, Reflesh page",
          });
        });
    },
    startEdit(index) {
      let vm = this;
      const item = vm.rewards_history[index];

      // Initialize edit values
      vm.$set(vm.rewards_history[index], 'isEditing', true);
      vm.$set(vm.rewards_history[index], 'editAmount', parseFloat(item.amount));
      vm.$set(vm.rewards_history[index], 'editCurrency', item.currency);
    },
    cancelEdit(index) {
      let vm = this;

      // Reset edit state
      vm.$set(vm.rewards_history[index], 'isEditing', false);
      vm.$set(vm.rewards_history[index], 'editAmount', null);
      vm.$set(vm.rewards_history[index], 'editCurrency', null);
    },
    saveEdit(index) {
      let vm = this;
      const item = vm.rewards_history[index];

      // Validate edit values
      if (!item.editAmount || item.editAmount <= 0) {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Invalid Amount",
          text: "Please enter a valid reward amount",
        });
        return;
      }

      if (!item.editCurrency || item.editCurrency.trim() === '') {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Invalid Currency",
          text: "Please enter a valid currency",
        });
        return;
      }

      // Check if amount exceeds remaining rewards (excluding current item)
      const otherRewards = vm.rewards_history.reduce((total, reward, idx) => {
        if (idx !== index) {
          return total + parseFloat(reward.amount || 0);
        }
        return total;
      }, 0);

      if (vm.remainingRewards !== null) {
        const availableForThisItem = vm.remainingRewards + parseFloat(item.amount);
        if (item.editAmount > availableForThisItem) {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Amount Exceeds Limit",
            text: `Requested amount (${item.editAmount}) exceeds available rewards (${availableForThisItem})`,
          });
          return;
        }
      }

      vm.isUpdating = true;

      // Prepare update data
      const updateData = {
        id: item.id,
        amount: item.editAmount,
        currency: item.editCurrency.trim(),
        participant_id: vm.participant.id,
        session_id: vm.session.id
      };

      vm.$store
        .dispatch("VOTING_UPDATE_PARTICIPANT_REWARD", updateData)
        .then((response) => {
          vm.isUpdating = false;

          // Update remaining rewards if provided
          if (response.data && response.data.remaining_rewards !== undefined) {
            vm.remainingRewards = response.data.remaining_rewards;
          }

          // Update the item with new values
          vm.$set(vm.rewards_history[index], 'amount', item.editAmount);
          vm.$set(vm.rewards_history[index], 'currency', item.editCurrency.trim());
          vm.$set(vm.rewards_history[index], 'isEditing', false);
          vm.$set(vm.rewards_history[index], 'editAmount', null);
          vm.$set(vm.rewards_history[index], 'editCurrency', null);

          vm.$notify({
            group: "status",
            type: "success",
            title: "Success!",
            text: "Reward updated successfully",
          });
        })
        .catch((error) => {
          vm.isUpdating = false;
          vm.$notify({
            group: "status",
            type: "error",
            title: "Error!",
            text: (error.response && error.response.data && error.response.data.message) || "Failed to update reward",
          });
        });
    },
    confirmDelete(index) {
      let vm = this;
      const item = vm.rewards_history[index];

      // Show confirmation dialog
      vm.$buefy.dialog.confirm({
        title: 'Delete Reward',
        message: `Are you sure you want to delete this reward of ${item.amount} ${item.currency}?`,
        confirmText: 'Delete',
        cancelText: 'Cancel',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.deleteReward(index);
        }
      });
    },
    deleteReward(index) {
      let vm = this;
      const item = vm.rewards_history[index];

      vm.isUpdating = true;

      // Prepare delete data
      const deleteData = {
        id: item.id,
        participant_id: vm.participant.id,
        session_id: vm.session.id
      };

      vm.$store
        .dispatch("VOTING_DELETE_PARTICIPANT_REWARD", deleteData)
        .then((response) => {
          vm.isUpdating = false;

          // Update remaining rewards if provided
          if (response.data && response.data.remaining_rewards !== undefined) {
            vm.remainingRewards = response.data.remaining_rewards;
          }

          // Remove the item from the array
          vm.rewards_history.splice(index, 1);

          vm.$notify({
            group: "status",
            type: "success",
            title: "Success!",
            text: "Reward deleted successfully",
          });
        })
        .catch((error) => {
          vm.isUpdating = false;
          vm.$notify({
            group: "status",
            type: "error",
            title: "Error!",
            text: (error.response && error.response.data && error.response.data.message) || "Failed to delete reward",
          });
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.pay-overlay {
  position: fixed !important;
  left: 0px;
  bottom: 0px;
  right: 0px;
  top: 0px;
  z-index: 9999999;
  display: flex;
  background-color: rgba($color: #000000, $alpha: 0.8);
  padding-top: 80px;
  padding-bottom: 30px;

  .modal-widget {
    margin: 0 auto;
    width: 400px;
    height: 100%;
    background: #fff;
    border-radius: 5px;

    @media screen and (max-width: 500px) {
      width: 100%;
      position: fixed;
      z-index: 999999999999999;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      height: auto;
      display: flex;
      flex-direction: column;
    }

    .modal-header {
      height: 50px;
      border-bottom: 1px solid #ddd;
      display: flex;
      align-items: center;
      padding-left: 20px;

      h2 {
        margin: 0px;
        font-size: 0.8rem;
        text-transform: uppercase;
      }
    }

    .modal-body {
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: calc(100% - 105px);
      position: relative;
      overflow-y: auto;

      &.fitt-bottom {
        height: calc(100% - 55px);
      }

      .modal-body-message {
        text-align: center;
        margin-bottom: 20px;
        font-size: 0.9rem;
      }

      .package-items {
        width: 100%;
        display: grid;
        grid-template-columns: 47% 47%;
        grid-gap: 20px;

        .package-item {
          border: 1px solid #ddd;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          cursor: pointer;
          padding: 10px;
          border-radius: 5px;
          position: relative;

          img {
            width: 15px;
            height: 15px;
            position: absolute;
            top: 8px;
            left: 8px;
            display: none;
          }

          h2 {
            font-size: 1.2rem;
            margin: 0 0 8px;
          }

          p {
            font-size: 0.9rem;
          }

          &:hover {
            border: 1px solid var(--wecodefy-secondary-color, #9fc953);
          }

          &.active {
            border: 1px solid var(--wecodefy-secondary-color, #9fc953);

            h2 {
              color: var(--wecodefy-secondary-color, #9fc953);
            }

            p {
              color: var(--wecodefy-secondary-color, #9fc953);
            }

            img {
              display: block;
            }
          }
        }
      }

      .loading-widget {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
      }
    }

    .modal-Footer {
      display: flex;
      padding: 0px 20px;
      border-top: 1px solid #ddd;
      height: 60px;
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 500px) {
        width: 100%;
        position: fixed;
        z-index: 999999999999999;
        left: 0px;
        bottom: 0px;
        right: 0px;
        display: flex;
        justify-content: center;
      }

      @media screen and (max-width: 340px) {
        padding-bottom: 5px;
      }

      .btn-success {
        margin-right: 20px;

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }
}

// Cool money input styles
.cool-money-input {
  display: flex;
  align-items: center;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  background: #fff;

  &:focus-within {
    border-color: var(--wecodefy-secondary-color, #9fc953);
    box-shadow: 0 0 0 3px rgba(159, 201, 83, 0.1);
  }

  .currency-symbol {
    background: var(--wecodefy-secondary-color, #9fc953);
    color: white;
    padding: 12px 16px;
    font-weight: bold;
    font-size: 1rem;
    min-width: 60px;
    text-align: center;
  }

  .money-input {
    border: none;
    outline: none;
    padding: 12px 16px;
    font-size: 1.1rem;
    font-weight: 600;
    flex: 1;
    background: transparent;
    color: #333;

    &::placeholder {
      color: #999;
      font-weight: normal;
    }

    // Hide number input spinners
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type=number] {
      appearance: textfield;
      -moz-appearance: textfield;
    }
  }
}

// Balance info styles
.balance-info {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  padding: 16px;
  margin-top: 10px;

  .balance-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 7px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      font-size: 0.9rem;
      color: #666;
      font-weight: 500;
      margin-bottom: 0;
    }

    .amount {
      font-size: 1rem;
      font-weight: 700;
      color: #333;
    }

    &.remaining {
      border-top: 1px solid #dee2e6;
      padding-top: 8px;
      margin-top: 8px;

      .amount {
        color: var(--wecodefy-secondary-color, #9fc953);
        font-size: 1.1rem;
      }
    }
  }
}

// Enhanced rewards history items
.rewards-history-items {
  width: 100%;
  margin-top: 20px;

  .rewards-history-item {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 8px;
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--wecodefy-secondary-color, #9fc953);
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .reward-display {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .reward-info {
        h2 {
          margin: 0;
          font-size: 1.1rem;
          font-weight: 700;
          color: var(--wecodefy-secondary-color, #9fc953);
        }

        p {
          margin: 0;
          font-size: 0.9rem;
          color: #666;
          font-weight: 500;
        }
      }

      .reward-actions {
        display: flex;
        gap: 8px;

        .btn-edit {
          background: var(--wecodefy-secondary-color, #9fc953);
          color: white;
          border: none;
          border-radius: 4px;
          padding: 8px 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 0.9rem;

          &:hover:not(:disabled) {
            background: #8bb849;
            transform: scale(1.05);
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          i {
            font-size: 0.8rem;
          }
        }

        .btn-delete {
          background: #dc3545;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 8px 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 0.9rem;

          &:hover:not(:disabled) {
            background: #c82333;
            transform: scale(1.05);
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          i {
            font-size: 0.8rem;
          }
        }
      }
    }

    .reward-edit {
      .edit-form {
        margin-bottom: 12px;

        .field {
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0;
          }

          .label {
            font-size: 0.8rem;
            color: #666;
            margin-bottom: 4px;
            display: block;
          }
        }
      }

      .edit-actions {
        display: flex;
        gap: 8px;
        justify-content: flex-end;

        .btn-save,
        .btn-cancel {
          border: none;
          border-radius: 4px;
          padding: 8px 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 0.9rem;

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          i {
            font-size: 0.8rem;
          }
        }

        .btn-save {
          background: #28a745;
          color: white;

          &:hover:not(:disabled) {
            background: darken(#28a745, 10%);
            transform: scale(1.05);
          }
        }

        .btn-cancel {
          background: #dc3545;
          color: white;

          &:hover:not(:disabled) {
            background: darken(#dc3545, 10%);
            transform: scale(1.05);
          }
        }
      }
    }
  }
}
</style>